import styled from 'styled-components';

export const StyledConfirmPossibleDuplicate = styled.div`
  min-width: 420px;
  .centered-form {
    width: 100%;
    display: flex;
    flex-direction: column;

    .bigger-text {
      margin-top: 10px;
      font-size: 120%;
      width: 100%;
      font-weight: bold;
    }
    .candidates {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-bottom: 30px;
      .ant-btn {
        font-size: 120%;
      }
    }
    .confirm-creation {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .center-button {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      .ant-btn {
        width: 25%;
      }
    }
  }
`;
